/**
 * String utility functions for formatting and transforming text
 */

/**
 * Capitalizes the first letter of each word in a string.
 * Also replaces underscores with spaces.
 * 
 * @param value - The string to capitalize
 * @returns The capitalized string with underscores replaced by spaces
 * 
 * @example
 * capitalizeWords('in_progress') // returns 'In Progress'
 * capitalizeWords('pending_review') // returns 'Pending Review'
 * capitalizeWords('completed') // returns 'Completed'
 */
export const capitalizeWords = (value: string): string => {
	if (!value) return value;
	
	return value
		.replace(/_/g, ' ') // Replace underscores with spaces
		.split(' ') // Split by spaces
		.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter of each word
		.join(' '); // Join back together
};
